/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import KpiCard from "../../../components/KpiCard/KpiCard";

import styled from "styled-components";
import { NavLink } from "react-router-dom/cjs/react-router-dom";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function CargosDesktop({ app, config }) {

  return (

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <Card
              app={app}
              header={{
                hardTitle: "Escolha o cargo e visualize o ranking em cada KPI",
              }}
              style={{ width: "100%", height: "100%" }}
              className={"container-ranking"}
            >
              <Grid
                container
                rowGap={2}
                justifyContent={"space-between"}
                marginTop={"16px"}
                paddingLeft={"10px"}
                flexWrap={"wrap"}
              >
                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Faturamento",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"8cdb83db-d3f2-4c61-8839-7e5e8f9c347a"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"b52a0753-e724-4fcb-bc80-92b02f51681c"}
                        goalValueId={"4637a87c-4a2f-467d-8f8b-134df3123dcb"}
                        percentageId={"4b207066-edec-4383-abb1-1e5b4c4878b5"} // no enter
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="8cdb83db-d3f2-4c61-8839-7e5e8f9c347a"
                        reference={{
                          id: "8cdb83db-d3f2-4c61-8839-7e5e8f9c347a",
                        }}
                        style={{ height: "300px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "%Fat. por Reppos",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"vUQrJ"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"5482db85-90b7-4ee4-95b8-4be866955d23"}
                        goalValueId={"2164391c-69c9-403f-a6c1-4aa71051338d"}
                        percentageId={"e1fda3ef-56ae-447b-8552-665b6feb7236"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="vUQrJ"
                        reference={{
                          id: "vUQrJ",
                        }}
                        style={{ height: "300px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Positivação",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"LaPfV"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"25fa0e5f-0bd8-4fd5-8fd6-de4a6f84ad53"}
                        goalValueId={"4a9e0cb4-9cf4-444c-9a6c-b87cac8dedfe"}
                        percentageId={"663ff15c-bd6e-4201-826a-3bf7a2804c91"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="LaPfV"
                        reference={{
                          id: "LaPfV",
                        }}
                        style={{ height: "300px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Positivação por Reppos",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"GKPnXB"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"8c7dd054-8c28-4764-852d-bf0e81cc87cd"}
                        goalValueId={"c23ef353-77c2-44fb-a418-9bb006377f35"}
                        percentageId={"7dd8bb6a-a138-4ca1-a8d2-c5fef5531b29"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="GKPnXB"
                        reference={{
                          id: "GKPnXB",
                        }}
                        style={{ height: "300px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "MSL",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"KJGPhfW"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"e769c789-b832-4e1a-aa00-220a15eb8d6d"}
                        goalValueId={"4a8ff770-2beb-43a6-a50a-06a0a5f5f6a1"}
                        percentageId={"e68bdfa0-0dde-4c8c-b0cf-4d761d1566d3"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="KJGPhfW"
                        reference={{
                          id: "KJGPhfW",
                        }}
                        style={{ height: "300px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>

                <Grid item width={"33%"}>
                  <LayoutCardWrapper>
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Total Acelera",
                      }}
                      style={{ width: "100%", height: "100%" }}
                      exportTable
                      exportTableId={"VbhBN"}
                      className={"container-table-kpi container-table"}
                    >
                      <KpiCard
                        app={app}
                        valueId={"6e91fcbd-e735-473a-bd2b-b6fa0559fcf6"}
                        goalValueId={"f52f7675-e141-46fe-812c-cb6b92430e68"}
                        percentageId={"f52f7675-e141-46fe-812c-cb6b92430e68"}
                        hasProgressBar={true}
                        fullView
                      ></KpiCard>

                      <NativeObject
                        app={app}
                        key="VbhBN"
                        reference={{
                          id: "VbhBN",
                        }}
                        style={{ height: "300px" }}
                      />
                    </Card>
                  </LayoutCardWrapper>
                </Grid>
              </Grid>
            </Card>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>

  );
}

CargosDesktop.defaultProps = {
  app: null,
  config: {},
};

CargosDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default CargosDesktop;
